export enum ExternalChatRequestAction {
  newAnonymousChat = 'newAnonymousChat',
}

export type ExternalChatRequestActionType = keyof typeof ExternalChatRequestAction;
